var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _text, _text2, _text3, _text4, _text5, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKollektiv42Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "100 70 120 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "155.1141009169893,175.24168609688527 135.00000000000006,80 29,168 29,216.8",
    fill: "rgb(238, 90, 132)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.42260651806146,270.74168609688525 155.1141009169893,175.24168609688527 29,216.8 29,265.6",
    fill: "rgb(14, 147, 95)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.4226065180614,392.25831390311475 285.42260651806146,270.74168609688525 29,265.6 29,314.4",
    fill: "rgb(228, 154, 0)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.1141009169893,354.75831390311475 301.4226065180614,392.25831390311475 29,314.4 29,363.2",
    fill: "rgb(60, 146, 135)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.9809625749134,451.9703005554963 281.1141009169893,354.75831390311475 29,363.2 29,412",
    fill: "rgb(14, 144, 11)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "K",
    transform: "translate(0 419)",
    fill: "rgba(67,67,67,0.27)",
    fontSize: 400,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "zig",
    transform: "translate(24.62 419)",
    fill: "#343434",
    fontSize: 100,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "0.656em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "zig"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "vier",
    transform: "translate(27.3 345)",
    fill: "#343434",
    fontSize: 100,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "0.312em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "vier"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "und",
    transform: "translate(22.3 269)",
    fill: "#343434",
    fontSize: 100,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "0.486em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "und"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "zwei",
    transform: "translate(24.6 187.46)",
    fill: "#343434",
    fontSize: 100,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "zwei"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 1,
    height: 7.47,
    transform: "translate(28.9 134.63)",
    fill: "#343434"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 1,
    height: 7.47,
    transform: "translate(28.9 366.17)",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKollektiv42Logo);
export default __webpack_public_path__ + "static/media/kollektiv42-logo.482c271880dd18e5ae9b22bc127e45e0.svg";
export { ForwardRef as ReactComponent };